import dotProp from 'dot-prop-immutable';

import {
  CLEAR_ESCALATED_FILTERS,
  SET_COMMUNICATION_TYPE_FOR_ESCALATED_FILTER,
  SET_EXCLUDE_BUSINESSES_FOR_ESCALATED_FILTER,
  SET_SELECTED_BUSINESSES_FOR_ESCALATED_FILTER,
} from '../actions/types';
import { communicationTypeFilterItems } from '../constants/conversationTypes';

const INITIAL_STATE = {
  selectedCommunicationFilterId: communicationTypeFilterItems[0].id,
  selectedBusinessForFilter: { idList: [], excludeBusinesses: false },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_COMMUNICATION_TYPE_FOR_ESCALATED_FILTER:
      return dotProp.set(state, 'selectedCommunicationFilterId', action.filterId);
    case SET_SELECTED_BUSINESSES_FOR_ESCALATED_FILTER:
      return dotProp.set(state, 'selectedBusinessForFilter.idList', action.businessIdList);
    case SET_EXCLUDE_BUSINESSES_FOR_ESCALATED_FILTER:
      return dotProp.set(state, 'selectedBusinessForFilter', { excludeBusinesses: action.value, idList: [] });
    case CLEAR_ESCALATED_FILTERS:
      return INITIAL_STATE;
    default:
      return state;
  }
};
